import styled from 'styled-components';

import {
  green,
  black,
  lightBlue,
  whitesmoke,
  border1,
} from 'utils/style/colors';
import { languageDirection } from '../../../i18n';

interface IStyleProps {
  isActive: boolean;
}

export const CategoryReportSelect = styled('div')`
  margin-bottom: 1rem;
`;

export const CountOfReportsInfo = styled('div')`
  display: flex;

  & :last-child {
    color: ${green};
    font-weight: 500;
    margin-right: 1rem;
  }
`;

export const ReportLists = styled('div')`
  border: ${border1};
  border-radius: 10px;
  overflow: hidden;
`;

export const SavedReportsContainer = styled('div')<IStyleProps>`
  display: ${(props) => (props.isActive ? 'flex' : 'none')};
  flex-direction: column;
  overflow: visible;
`;

export const SavedReportsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  overflow: visible;
`;

export const ActionSection = styled('div')`
  height: 100%;
  position: absolute;
  top: 0;
  background-color: ${whitesmoke};
  display: flex;
  justify-content: ${(_) =>
    languageDirection() === 'rtl' ? 'center' : 'flex-end'};
  align-items: center;
  visibility: hidden;
  ${(_) =>
    languageDirection() === 'rtl'
      ? 'left: 2.5rem !important;'
      : 'right: 2.5rem !important;'}
`;

export const ActionIcon = styled.div`
  height: 100%;
  padding: 0.25rem;
  //color: white;
  cursor: pointer;
`;

export const EditItemIcon = styled('div')<IStyleProps>`
  height: 100%;
  cursor: pointer;
  display: inline-flex;
  padding: 0.25rem;
  align-items: center;
  background-color: ${whitesmoke};
  position: relative;
  top: 0;
  left: ${(props) => (props.theme.direction === 'rtl' ? '0' : 'unset')};
  right: ${(props) => (props.theme.direction === 'ltr' ? '0' : 'unset')};
  &:hover {
    color: #aaaaaa;
  }
`;

export const ListItem = styled('div')<IStyleProps>`
  height: 3rem;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  cursor: pointer;
  color: ${(props) => (props.isActive ? green : black)};
  border-inline-start: ${(props) => props.isActive && `2px solid ${green}`};
  transition: all 0.2s ease;
  position: relative;
  border-bottom: ${border1};
  background: ${(props) => props.isSelectedToDelete && lightBlue};
  &:hover {
    background-color: ${(props) =>
      props.isSelectedToDelete ? lightBlue : whitesmoke};
  }
  & > span {
    padding: 0.5rem;
  }
  &:hover ${EditItemIcon} {
    //background-color: #eee;
  }
  &:hover ${ActionSection} {
    //background-color: #eee;
    visibility: visible;
    ${(_) => (languageDirection() === 'rtl' ? 'left: 25px;' : 'right: 25px')}
  }
`;

export const Section = styled('div')`
  display: flex;
  align-items: center;
`;
